// ─────────────────────────────────────────────────────────────────────────────
// Shared customer-portal design tokens.
//
// Re-points the portal onto the main app's design system so both surfaces read
// as one product: hairline cards with soft depth, the ambient brand background,
// and one status palette (replacing the three divergent Material palettes the
// portal pages each used to carry).
// ─────────────────────────────────────────────────────────────────────────────
import { ambientBackground } from '../../styles/glass';

export { ambientBackground };

// Standard app card — hairline border + soft shadow, matching the list pages.
export const portalCardSx = {
    backgroundColor: '#fff',
    border: '1px solid #e6ecf1',
    borderRadius: '14px',
    boxShadow: '0 1px 2px rgba(16,42,66,0.04), 0 12px 28px -18px rgba(30,58,82,0.14)',
    overflow: 'hidden',
};

// One status palette for every portal domain (quotes, contracts, invoices,
// projects) — the same hues used on the dashboard and admin list pages.
export const STATUS_COLORS = {
    // neutral / not-started
    DRAFT: '#94a3b8', PENDING: '#94a3b8',
    // in-flight / informational
    SENT: '#3b82f6', ISSUED: '#3b82f6', ONGOING: '#3b82f6',
    // waiting on someone
    SIGNING: '#f59e0b', AWAITING_SIGNATURE: '#f59e0b',
    AWAITING_CUSTOMER_SIGNATURE: '#f59e0b', PARTIALLY_PAID: '#f59e0b',
    CHANGES_REQUESTED: '#f97316',
    // success / done
    SIGNED: '#10b981', ACCEPTED: '#10b981', ACTIVE: '#10b981',
    COMPLETED: '#10b981', PAID: '#10b981',
    // problem
    OVERDUE: '#ef4444', REJECTED: '#ef4444',
    // closed / inactive
    CANCELLED: '#cbd5e1', CANCELED: '#cbd5e1', EXPIRED: '#cbd5e1',
    TERMINATED: '#64748b', WRITTEN_OFF: '#64748b',
};

export const statusColor = (status) => STATUS_COLORS[status] || '#94a3b8';

// Title-case fallback label from a raw status enum (e.g. CHANGES_REQUESTED → "Changes requested").
export const humanizeStatus = (status) => {
    if (!status) return '';
    const s = status.replace(/_/g, ' ').toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
};
